module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/manage/manage.component.css
// module id = ./src/app/Pages/manage/manage.component.css
// module chunks = main